/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { HoedanigheidpickerDto } from '../models/hoedanigheidpicker-dto';

@Injectable({
  providedIn: 'root',
})
export class HoedanigheidpickerApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getHoedanigheden
   */
  static readonly GetHoedanighedenPath = '/api/extern/hoedanigheidpicker/get-hoedanigheden';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHoedanigheden$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanigheden$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<HoedanigheidpickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HoedanigheidpickerApiService.GetHoedanighedenPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HoedanigheidpickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHoedanigheden$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanigheden$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<HoedanigheidpickerDto>> {

    return this.getHoedanigheden$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HoedanigheidpickerDto>>) => r.body as Array<HoedanigheidpickerDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHoedanigheden()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanigheden$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<HoedanigheidpickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HoedanigheidpickerApiService.GetHoedanighedenPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HoedanigheidpickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHoedanigheden$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanigheden(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<HoedanigheidpickerDto>> {

    return this.getHoedanigheden$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HoedanigheidpickerDto>>) => r.body as Array<HoedanigheidpickerDto>)
    );
  }

  /**
   * Path part for operation getHoedanighedenForPickerByAction
   */
  static readonly GetHoedanighedenForPickerByActionPath = '/api/extern/hoedanigheidpicker/get-hoedanigheden-by-action';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHoedanighedenForPickerByAction$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanighedenForPickerByAction$Plain$Response(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<HoedanigheidpickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HoedanigheidpickerApiService.GetHoedanighedenForPickerByActionPath, 'get');
    if (params) {
      rb.query('actie', params.actie, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HoedanigheidpickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHoedanighedenForPickerByAction$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanighedenForPickerByAction$Plain(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<HoedanigheidpickerDto>> {

    return this.getHoedanighedenForPickerByAction$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HoedanigheidpickerDto>>) => r.body as Array<HoedanigheidpickerDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHoedanighedenForPickerByAction()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanighedenForPickerByAction$Response(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<HoedanigheidpickerDto>>> {

    const rb = new RequestBuilder(this.rootUrl, HoedanigheidpickerApiService.GetHoedanighedenForPickerByActionPath, 'get');
    if (params) {
      rb.query('actie', params.actie, {});
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<HoedanigheidpickerDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getHoedanighedenForPickerByAction$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHoedanighedenForPickerByAction(params?: {
    actie?: string;

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<HoedanigheidpickerDto>> {

    return this.getHoedanighedenForPickerByAction$Response(params).pipe(
      map((r: StrictHttpResponse<Array<HoedanigheidpickerDto>>) => r.body as Array<HoedanigheidpickerDto>)
    );
  }

}
